import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { EventTypes } from '../../EventTypes';
import { TweenMax, Quint } from 'gsap';
import { SharedService } from '../../shared.service';
import { ModalAnswerEventType } from './modal-answer.event.type';

@Component({
	selector: 'app-modal-answer',
	templateUrl: './modal-answer.component.html',
	styleUrls: ['./modal-answer.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ModalAnswerComponent implements OnInit, OnDestroy {

	question: string;
	answer: string;
	acceptHandler: any;
	acceptHandlerData: any;
	loading = false;
	access: any;

	constructor(private sharedService: SharedService ) { }

	ngOnInit() {
		AppEventDispatcher.listen( EventTypes.MODAL_ANSWER.MODAL_ANSWER, data => {
			this.question = data.question;
			this.answer = data.answer;
			this.acceptHandler = data.acceptHandler;
			this.acceptHandlerData = data.acceptHandlerData;
			this.access = data.access;
			this.show();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(EventTypes.MODAL_ANSWER.MODAL_CLOSE);
	}

	show() {
		$('[data-component="modal-answer"]').show();
		TweenMax.to('[data-component="modal-answer"] .modal', 1, {top: '30%', ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to('[data-component="modal-answer"] .modal', .6, {top: '-150%', ease: Quint.easeIn, onComplete: () => {
			$('[data-component="modal-answer"]').hide();
			$('[data-component="modal-answer"]').appendTo('app-modal-answer');
		}});
	}

	ok() {
		this.hide();
		AppEventDispatcher.dispatch(EventTypes.MODAL_ANSWER.MODAL_CLOSE, { question: this.question, answer: this.answer });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/custumer-service-client-info/modal-answer/modal-answer.component.ts